import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import PublicNavbar from "../components/PublicNavbar";
import PublicFooter from "../components/PublicFooter";

/**
 * Public shell — design system tokens only (var(--bg), public-shell, public-navbar).
 * Landing keeps its own header; other public pages use PublicNavbar + Footer.
 */
export default function PublicLayout() {
  const { pathname } = useLocation();
  const isLanding = pathname === "/" || pathname === "/home";

  useEffect(() => {
    try {
      const th = localStorage.getItem("ca_theme") || "dark";
      document.documentElement.setAttribute(
        "data-theme",
        th === "light" ? "light" : ""
      );
    } catch (_) {}
  }, [pathname]);

  return (
    <div className="public-shell" style={{ background: "var(--bg)", color: "var(--text-main)" }}>
      {!isLanding && <PublicNavbar />}
      <Outlet />
      {!isLanding && <PublicFooter />}
    </div>
  );
}
